export const evhMarkerDataSelector = ({evhMarkerData}) => evhMarkerData